module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/01a3b56eef292b43a137f9223b8a4934.png";